// Frozen so the generated declaration carries the string literals rather than
// widening every member to string.
export const SEGMENT_TYPE = Object.freeze({
  ENTRY: 'entry',
  EXIT: 'exit',

  POINT: 'point',
  STAY: 'stay',
  SERVICE: 'service',
  PRICE: 'price',

  FLIGHT: 'flight',
  CHARTERED: 'chartered',
  SCHEDULED: 'scheduled',

  ROAD: 'road',
  BOAT: 'boat', // Road subtype.
  TRAIN: 'train', // Road subtype.
  WALK: 'walk', // Road subtype.
  HELICOPTER: 'helicopter', // Road subtype.
});

// Frozen for the same reason: the declaration is a readonly array of the
// member literals, derived from the values themselves.
export const FLIGHT_TYPES = Object.freeze([SEGMENT_TYPE.FLIGHT, SEGMENT_TYPE.CHARTERED, SEGMENT_TYPE.SCHEDULED]);

export const ROAD_TYPES = Object.freeze([
  SEGMENT_TYPE.ROAD,
  SEGMENT_TYPE.BOAT,
  SEGMENT_TYPE.TRAIN,
  SEGMENT_TYPE.WALK,
  SEGMENT_TYPE.HELICOPTER,
]);

export const TRANSIT_TYPES = Object.freeze([...FLIGHT_TYPES, ...ROAD_TYPES]);
